import style from './SideMenuBtn.module.css';

import { AiFillMedicineBox, AiOutlineLoading3Quarters, AiOutlineFilePdf } from "react-icons/ai";
import { IoHome, IoPersonAddSharp, IoDocumentText, IoTicket, IoCardOutline } from "react-icons/io5";
import { FaMapMarkerAlt, FaDollarSign, FaListUl } from "react-icons/fa";
import { FaListCheck } from "react-icons/fa6";
import { FaMoneyCheckDollar, FaHelmetSafety } from "react-icons/fa6";
import { RiFileExcel2Line, RiHealthBookFill } from "react-icons/ri";
import { BiSolidHelpCircle, BiTransfer, BiErrorCircle, BiSolidError } from "react-icons/bi";
import { GiHealthNormal, GiOrganigram } from "react-icons/gi";
import { IoMdAdd, IoMdClose, IoMdCheckmark } from "react-icons/io";
import { BsListCheck } from "react-icons/bs";
import { HiDocumentText } from "react-icons/hi";
import { HiOutlineClipboardDocumentList, HiOutlinePaperAirplane } from "react-icons/hi2";
import { CiViewList } from "react-icons/ci";
import { BsFilePerson } from "react-icons/bs"
import { LuFileBadge, LuFilePenLine, LuClipboardList } from "react-icons/lu";
import { PiLeafFill } from "react-icons/pi";
import { GrConfigure, GrCatalogOption, GrDocumentConfig } from "react-icons/gr";
import { FiClock, FiMail, FiUserCheck } from "react-icons/fi";


const iconMap = {
    'AFASTAMENTOS' : RiHealthBookFill,
    'ATENDIMENTOS' : BiSolidHelpCircle,
    'EXAMES OCUPACIONAIS' : GiHealthNormal,
    'FOLGA DE CAMPO' : FaMapMarkerAlt,
    'FOLHA DE PAGAMENTO' : FaMoneyCheckDollar,
    'GERAR RELATÓRIO' : RiFileExcel2Line,
    'PROCESSO ADM/TRANSF' : IoPersonAddSharp,
    'CONTROLE DE EXPERIÊNCIA' : IoDocumentText,
    'REPUBLICAS' : IoHome,
    'NOVA REPÚBLICA' : IoHome,
    'GERAR RELATÓRIO PDF' : AiOutlineFilePdf,
    'GERAR RELATÓRIO EXCEL' : RiFileExcel2Line,

    'SOLICITAR ASO': AiFillMedicineBox,
    'BENEFÍCIOS': FaDollarSign,
    'NOVO COLABORADOR': IoPersonAddSharp,
    'TRANSFERIR COLABORADOR': BiTransfer,
    'NOVA AUDITORIA': IoMdAdd,
    'NOVA RAC': IoMdAdd,
    'REGISTRAR NOVO ITEM': IoMdAdd,
    'PLANEJAR SETOR': IoMdAdd,
    "ITENS PENDENTES": BsListCheck,
    "CANCELAR AUDITORIA": IoMdClose,
    "FINALIZAR AUDITORIA": IoMdCheckmark,
    "RAC": HiDocumentText,
    "AUDITORIA INTERNA": HiOutlineClipboardDocumentList,
    "NOVO": IoMdAdd,
    "GERAR LISTA DE PRESENÇA": CiViewList,
    "GERAR CRACHÁ": BsFilePerson,
    "TREINAMENTOS | FUNÇÃO": BsListCheck,
    "TREINAMENTOS" : LuFileBadge,
    "DESVIOS" : LuFilePenLine,
    'ATENDIMENTO AMBULAT.' : GiHealthNormal,
    "INSPEÇÃO DE SST" : IoDocumentText,
    "INSPEÇÃO AMBIENTAL" : PiLeafFill,
    "PAINEL DE CONTROLE" : GrConfigure,

    "TREINAMENTOS PROGRAMADOS" : FiClock,
    "CRONOGRAMA" : FiClock,
    "CADASTRAR TREINAMENTO" : IoMdAdd,
    "CADASTRAR" : IoMdAdd,
    "PEDIDOS DE EPI" : FaMoneyCheckDollar,
    "LISTA EPI'S" : FaHelmetSafety,
    "EPI'S x FUNÇÃO" : FaListUl,
    "ORGANOGRAMA COLABS": GiOrganigram,
    "GERAR DDS": IoMdAdd,
    "DDS": LuClipboardList,
    "EPI-CONTROLE": FaHelmetSafety,
    "CHECK-LIST": FaListCheck,
    "CATÁLOGO": GrCatalogOption,
    "CHECKLIST INFO": GrDocumentConfig,
    "NÃO CONFORMIDADES": BiSolidError,
    "NOVO CHECKLIST": IoMdAdd,
    "CIPA": IoTicket,
    "NOVO DESVIO": IoMdAdd,
    "INVESTIGAÇÕES": LuFilePenLine,
    "NOVO PEDIDO DE COMPRA": IoMdAdd,
    "ADICIONAR PC": IoMdAdd,
    "NOVO LANÇAMENTO": IoMdAdd,
    "GERENCIAR E-MAILS": FiMail,
    "NFs PENDENTES (BM)": HiOutlineClipboardDocumentList,
    "LIBERAR OBRAS": FiUserCheck,
    /* Folha de Pagamento (sidebar) */
    "RELATÓRIO DE REFERÊNCIA": RiFileExcel2Line,
    "APONTAMENTO DE FOLHA": HiOutlinePaperAirplane,
    "APONTAMENTO DE V.A": IoCardOutline,

}

const SideMenuBtn = ({ button, clickFunc, isLoading }) => {

    const IconComponent = iconMap[button] || BiErrorCircle;

    return(
        <div
            className={ style.sideMenuBtn }
            onClick={ !isLoading ? clickFunc : undefined }
            role='button'
        >

            <div className={ style.divIcon } >
                { isLoading ? <AiOutlineLoading3Quarters className={ style.spinner } /> : <IconComponent /> }
            </div>
            <p>{ button }</p>
        </div>
    )

}

export default SideMenuBtn;